import { ConnectedRouter } from "connected-react-router";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { Provider } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
// import Paper from "@material-ui/core/Paper";
import "./App.css";

import configureStore, { history } from "./redux/store";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import loading from "./pages/Loading";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";

const ParticipantList = lazy(() => import("./pages/ParticipantList"));
const ParticipantView = lazy(() => import("./pages/ParticipantView"));
const QuestionList = lazy(() => import("./pages/QuestionList"));
const ServiceList = lazy(() => import("./pages/ServiceList"));
const Tabs = lazy(() => import("./pages/Tabs"));
const VerifyEmail = lazy(() => import("./pages/VerifyEmail"));
const ViewShot = lazy(() => import("./pages/ViewShot"));
const AddParticipant = lazy(() => import("./pages/AddParticipant/AddParticipant"));
const AccountSettings = lazy(() => import("./pages/AccountSettings"));
const EditAccountSettings = lazy(() => import("./pages/EditAccountSettings"));
const ChangePassword = lazy(() => import("./pages/ChangePassword"));
const EditParticipant = lazy(() => import("./pages/EditParticipant"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Home = lazy(() => import("./pages/Home"));
const Interviewees = lazy(() => import("./pages/Interviewees"));
const InterviewSetup = lazy(() => import("./pages/InterviewSetup"));
const IntroOutro = lazy(() => import("./pages/IntroOutro"));
const LanguageList = lazy(() => import("./pages/LanguageList"));
const Login = lazy(() => import("./pages/Login"));
const NewPassword = lazy(() => import("./pages/NewPassword"));

const store = configureStore({});

function App() {
	useEffect(() => {
	//check the pallete selected
			
	}, [])

	return (
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Suspense
					fallback={
						<div
							style={{
								height: "100%",
								display: "flex",
								justifyContent: "center",
								alignItems: "center"
							}}
						>
							<CircularProgress />
						</div>
					}
				>
					<Switch>
						<Route path="/" exact component={loading()} />
						<Route path="/login" exact render={props => <Login {...props} />} />
						<Route path="/forgot-password" exact component={ForgotPassword} />
						<Route path="/change-password" exact component={loading(ChangePassword)} />
						<Route path="/verify-email" exact component={VerifyEmail} />
						<Route path="/new-password" exact component={NewPassword} />
						<Route path="/account/settings" exact component={loading(AccountSettings)} />
						<Route path="/account/settings/:id" exact component={loading(EditAccountSettings)} />
						<Route path="/home/shoot/:clinic/:date/shots/photo/view/:id" exact component={loading(ViewShot)} />
						<Route path="/home/shoot/:clinic/:date/shots/video/view/:id" exact component={loading(ViewShot)} />
						<Route path="/home/shoot/:clinic/:date/interview/setup" exact component={loading(InterviewSetup)} />
						<Route path="/home/shoot/:clinic/:date/interview/questions" exact component={loading(QuestionList)} />

						<Route path="/home/shoot/:clinic/:date/other/services" exact component={loading(ServiceList)} />
						<Route path="/home/shoot/:clinic/:date/other/languages" exact component={loading(LanguageList)} />
						<Route path="/home/shoot/:clinic/:date/other/participants" exact component={loading(ParticipantList)} />
						<Route path="/home/shoot/:clinic/:date/other/participants/add" exact component={AddParticipant} />
						<Route path="/home/shoot/:clinic/:date/other/participants/:id" exact component={loading(ParticipantView)} />
						<Route path="/home/shoot/:clinic/:date/other/participants/:id/edit" exact component={loading(EditParticipant)} />

						<Route path="/home/shoot/:clinic/:date/interview/interviewees" exact component={loading(Interviewees)} />
						<Route path="/home/shoot/:clinic/:date/interview/introoutro" exact component={loading(IntroOutro)} />

						<Route path="/home/shoot/:clinic/:date" component={loading(Tabs)} />
						<Route path="/home" exact component={loading(Home)} />
						<Redirect to="/" />
					</Switch>
				</Suspense>
			</ConnectedRouter>
			{/* <ConfirmationDialog /> */}
		</Provider>
	);
}

export default App;
